import styled from 'styled-components';

export const SelectWrapperStyled = styled.div`
  max-height: 280px;
  overflow-y: auto;
  overflow-x: hidden;
  margin: 16px -24px 0;
`;

export const SelectItemStyled = styled.div`
  margin: 0 24px;
`;

export const SelectOptionsListStyled = styled.div`
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
`;

export const SelectOptionStyled = styled.label`
  display: flex;
  padding: 0 24px;

  &:focus-within,
  &:hover {
    background: var(
      --ds-surface-overlay-hovered,
      var(--ds-fb-surface-overlay-hovered)
    );
  }
`;

export const SelectOptionsListCheckboxStyled = styled.div`
  min-height: 32px;
  display: flex;
  align-items: flex-start;
`;

export const SelectOptionsListCheckboxContainerStyled = styled.div`
  min-height: 32px;
  display: flex;
  align-items: center;
`;

export const SelectOptionsListContentWrapperStyled = styled.div``;

export const SelectViewContentStyled = styled.div`
  width: 320px;

  @media (min-width: 640px) {
    width: 480px;
  }
`;

export const SelectContentBodyStyled = styled.div`
  padding: 24px;
`;
